// Module
var code = "<label class=\"ndd-ng-form-internal-label\" [ngClass]=\"{ 'ndd-ng-form-internal-label--required': controlRequired }\" [for]=\"controlForId\" *ngIf=\"controlLabel\"> {{ controlLabel }}<strong class=\"ndd-ng-form-internal-label__strong\" *ngIf=\"controlRequired\">*</strong> </label> ";
// Exports
module.exports = code;